import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { Switch } from '../ui/switch';

const EMPTY = { title: '', description: '', location_ids: [], email_to: '', email_cc: '', is_active: true };

export const SituationFormDialog = ({ open, item, locations, onClose, onSave }) => {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setForm({ ...EMPTY, ...(item || {}) }); }, [open, item]);
  const set = (patch) => setForm(prev => ({ ...prev, ...patch }));
  const toggleLoc = (id, on) => set({ location_ids: on ? [...form.location_ids, id] : form.location_ids.filter(x => x !== id) });
  const allOn = locations.length > 0 && form.location_ids.length === locations.length;

  const submit = async () => {
    setSaving(true);
    await onSave({ title: form.title.trim(), description: form.description.trim(), location_ids: form.location_ids, email_to: form.email_to, email_cc: form.email_cc, is_active: form.is_active });
    setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="situation-form-dialog">
        <DialogHeader><DialogTitle>{item?.id ? 'Özel Durumu Düzenle' : 'Yeni Özel Durum'}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label>Başlık *</Label>
            <Input value={form.title} onChange={(e) => set({ title: e.target.value })} placeholder="ör. Gürültülü Çalışma" data-testid="situation-title-input" />
          </div>
          <div className="space-y-1.5">
            <Label>Açıklama <span className="text-xs text-slate-400">(isteğe bağlı)</span></Label>
            <Input value={form.description} onChange={(e) => set({ description: e.target.value })} placeholder="ör. Kırım, delme vb. yüksek sesli işlemler" data-testid="situation-desc-input" />
          </div>
          <div className="space-y-1.5">
            <div className="flex items-center justify-between">
              <Label>Görüneceği Lokasyonlar</Label>
              <button type="button" className="text-xs text-blue-600 hover:underline" onClick={() => set({ location_ids: allOn ? [] : locations.map(l => l.id) })} data-testid="situation-loc-toggle-all">{allOn ? 'Tümünü kaldır' : 'Tümünü seç'}</button>
            </div>
            <div className="grid sm:grid-cols-2 gap-2 p-3 border rounded-lg bg-slate-50 max-h-48 overflow-y-auto" data-testid="situation-locations">
              {locations.map(l => (
                <label key={l.id} className="flex items-center gap-2 text-sm cursor-pointer">
                  <Checkbox checked={form.location_ids.includes(l.id)} onCheckedChange={(v) => toggleLoc(l.id, !!v)} data-testid={`situation-loc-${l.id}`} />{l.name}
                </label>
              ))}
            </div>
          </div>
          <div className="space-y-1.5">
            <Label>E-posta TO</Label>
            <Input value={form.email_to} onChange={(e) => set({ email_to: e.target.value })} placeholder="ornek1@firma.com; ornek2@firma.com" data-testid="situation-email-to-input" />
          </div>
          <div className="space-y-1.5">
            <Label>E-posta CC</Label>
            <Input value={form.email_cc} onChange={(e) => set({ email_cc: e.target.value })} placeholder="ornek3@firma.com; ornek4@firma.com" data-testid="situation-email-cc-input" />
            <p className="text-xs text-slate-500">Birden fazla adresi ";" ile ayırın. Talep onaylandığında bu durum seçildiyse bu adreslere bildirim gider.</p>
          </div>
          <label className="flex items-center gap-2 text-sm"><Switch checked={form.is_active} onCheckedChange={(v) => set({ is_active: v })} data-testid="situation-active-switch" />Aktif (pasif durumlar talepte görünmez)</label>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="situation-cancel-btn">Vazgeç</Button>
          <Button onClick={submit} disabled={!form.title.trim() || saving} data-testid="situation-save-btn">Kaydet</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
